<div class="page-footer">

  <div class="fix-row">
    <div class="col-lg-5 col-12"></div>

    <!-- Coding with Kids -->
    <div class="col-lg-2 col-12 text-center">
      <!--div>Tax ID: 45-4779162</div-->
    </div>

    <div class="col-lg-5 col-12">
      <div class="d-flex flex-wrap mt-1 mt-lg-0 justify-content-center justify-content-lg-end">
        <a class="me-3 me-lg-0 ms-0 ms-lg-3 cwk-link theme-link-color" href="{{ urlRoot + '/privacy-policy' }}">Privacy Policy</a>
        <a class="me-3 me-lg-0 ms-0 ms-lg-3 cwk-link theme-link-color" href="{{ urlRoot + '/terms-of-service' }}">Terms of Service</a>
        <a class="me-3 me-lg-0 ms-0 ms-lg-3 cwk-link theme-link-color" href="mailto:info@coderace.org" target="_blank">Contact Us</a>
        <span class="ms-0 ms-lg-3 cwk-link theme-link-color" (click)="onClickManageCookies()">Privacy Settings</span>
      </div>

      <div class="mt-1 d-flex justify-content-center justify-content-lg-end">
        <span>&copy; {{ now | date:'YYYY' }}, Code Race&trade;</span>
      </div>
    </div>
  </div>
</div>
